var React = require('react');

function ContactUs (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Mail"},[React.createElement("rect",{"id":"Rectangle 2","x":"1.66663","y":"1.3335","width":"16.6667","height":"13.3333","rx":"4.16667","stroke":"#121212","strokeWidth":"1.5","key":0}),React.createElement("path",{"id":"Line","d":"M4.99994 5.5L8.99994 8.5C9.59253 8.94444 10.4073 8.94444 10.9999 8.5L14.9999 5.5","stroke":"#121212","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

ContactUs.defaultProps = {"width":"20","height":"16","viewBox":"0 0 20 16","fill":"none"};

module.exports = ContactUs;

ContactUs.default = ContactUs;
